/* ---------------------------------------------------------------------------
 * Product options extension
 *
 * 1. Existing behaviour: checkbox options bump the quantity field.
 * 2. Added: block Add to Cart until every visible option has been chosen.
 *
 * Why 2 exists. The options app renders "-- Choose X --" placeholders but does
 * not enforce them, so a custom shaft could be added to the cart with no tip
 * adapter, no playing length and no grip. Those orders reach the bench
 * unbuildable. Reproduced on the live theme before this was written.
 *
 * A field counts as unanswered when it is visible and its select is still on
 * the placeholder. Hidden options are skipped on purpose: the app hides the
 * ones that do not apply to the current selection, and requiring those would
 * make Add to Cart impossible.
 * ------------------------------------------------------------------------- */
(function () {
  'use strict';

  /* ---------- 1. quantity sync for checkbox options (unchanged) ---------- */
  var productForm = document.querySelector('product-form');
  if (productForm) {
    productForm.addEventListener('change', function (event) {
      var checkboxes = document.querySelectorAll('.bold_option_value_element input[type="checkbox"]');
      var qtyInput = document.querySelector('input[name="quantity"]');
      if (checkboxes.length > 0 && qtyInput) {
        checkboxes.forEach(function (checkbox) {
          if (event.target === checkbox) {
            checkbox.checked ? qtyInput.value++ : qtyInput.value--;
          }
        });
      }
    });
  }

  /* ---------- 2. require the visible options ---------- */
  var STYLE_ID = 'tqg-required-options-style';
  if (!document.getElementById(STYLE_ID)) {
    var st = document.createElement('style');
    st.id = STYLE_ID;
    st.textContent =
      '.tqg-opt-missing select{border-color:#B4491A !important;box-shadow:0 0 0 1px #B4491A}' +
      '.tqg-opt-missing.tqg-opt-missing--radio{outline:1px solid #B4491A;outline-offset:4px}' +
      '.tqg-opt-msg{display:block;margin-top:6px;color:#B4491A;font-size:1.3rem;font-weight:600}' +
      '.tqg-cart-msg{margin:12px 0;padding:11px 14px;border:1px solid #B4491A;' +
      'border-radius:2px;color:#B4491A;font-size:1.4rem;font-weight:600}';
    document.head.appendChild(st);
  }

  function isVisible(el) {
    return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length);
  }

  function isUnanswered(select) {
    if (!select.value) return true;
    var opt = select.options[select.selectedIndex];
    return !!(opt && /^\s*--\s*choose/i.test(opt.text));
  }

  function titleEl(block) {
    return block.querySelector('.bold_option_title');
  }

  function labelFor(block, control) {
    var t = titleEl(block);
    var text = t ? t.textContent : (control.name || 'this option');
    return text.replace(/\s+/g, ' ').replace(/\*/g, '').trim();
  }

  // Returns the list of option blocks the shopper still has to answer.
  function findMissing(form) {
    var missing = [];
    form.querySelectorAll('.bold_option').forEach(function (block) {
      if (block.classList.contains('bold_option_hidden')) return;
      if (!isVisible(block)) return;

      var select = block.querySelector('select');
      if (select) {
        if (select.disabled || !isVisible(select)) return;
        if (isUnanswered(select)) missing.push({ block: block, control: select });
        return;
      }

      /* Radio groups.
       *
       * Found by testing a complete build: "Grip Logo" ships with neither Up
       * nor Down checked, and the app refuses the add with a bare
       * "This option is required." that names no field and sits beside a 13px
       * radio. The add silently fails and no /cart/add request is ever made.
       *
       * Gated on the app's own asterisk marker so this can only ever flag what
       * the app already requires. That keeps the guard additive: it improves
       * the message and never blocks a build the app would have accepted. */
      var radios = block.querySelectorAll('input[type="radio"]');
      if (radios.length) {
        var t = titleEl(block);
        var required = !!(t && t.textContent.indexOf('*') !== -1);
        if (!required || !isVisible(radios[0])) return;
        var answered = false;
        radios.forEach(function (r) { if (r.checked) answered = true; });
        if (!answered) missing.push({ block: block, control: radios[0], radio: true });
      }
    });
    return missing;
  }

  function clearMarks(form) {
    form.querySelectorAll('.tqg-opt-missing').forEach(function (el) {
      el.classList.remove('tqg-opt-missing', 'tqg-opt-missing--radio');
    });
    form.querySelectorAll('.tqg-opt-msg, .tqg-cart-msg').forEach(function (el) {
      el.remove();
    });
  }

  function markMissing(form, missing) {
    clearMarks(form);
    missing.forEach(function (item) {
      item.block.classList.add('tqg-opt-missing');
      if (item.radio) item.block.classList.add('tqg-opt-missing--radio');
      var msg = document.createElement('span');
      msg.className = 'tqg-opt-msg';
      msg.textContent = 'Please choose ' + labelFor(item.block, item.control) + '.';
      item.block.appendChild(msg);
    });

    var summary = document.createElement('div');
    summary.className = 'tqg-cart-msg';
    summary.setAttribute('role', 'alert');
    summary.textContent =
      missing.length === 1
        ? 'One more choice needed before this can be added to the cart.'
        : missing.length + ' more choices needed before this can be added to the cart.';
    var btn = form.querySelector('button[type="submit"]');
    if (btn && btn.parentNode) btn.parentNode.insertBefore(summary, btn);

    missing[0].control.scrollIntoView({ block: 'center', behavior: 'smooth' });
    try { missing[0].control.focus({ preventScroll: true }); } catch (e) {}
  }

  function guard(event) {
    var form = event.target.closest
      ? event.target.closest('form[action*="/cart/add"]')
      : null;
    if (!form) return;
    if (!form.querySelector('.bold_option')) return; // product has no options

    var missing = findMissing(form);
    if (missing.length === 0) {
      clearMarks(form);
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();
    markMissing(form, missing);
  }

  // Capture phase on document so this runs before the theme's own handlers
  // and before the app's AJAX submit.
  document.addEventListener('submit', guard, true);
  document.addEventListener(
    'click',
    function (event) {
      var btn = event.target.closest && event.target.closest('button[type="submit"]');
      if (!btn) return;
      var form = btn.closest('form[action*="/cart/add"]');
      if (!form || !form.querySelector('.bold_option')) return;
      var missing = findMissing(form);
      if (missing.length > 0) {
        event.preventDefault();
        event.stopImmediatePropagation();
        markMissing(form, missing);
      }
    },
    true
  );

  // Clear the warning as soon as the shopper answers.
  document.addEventListener('change', function (event) {
    var form = event.target.closest && event.target.closest('form[action*="/cart/add"]');
    if (!form) return;
    if (findMissing(form).length === 0) clearMarks(form);
  });
})();
